export { default as default } from './Pastilla';
